var cio_datamodel = require("cio-datamodel");
var editor_2d = require("editor-2d");
var drawHoleDataTo2D = require("./drawHoleDataTo2D");

var drawHoleOfPadDataTo2D = function (svg, group, data) {
    console.assert(data.padstack() instanceof cio_datamodel.PthPadstackData);
    var g = svg.group(group);
    drawHoleDataTo2D(svg, g, data.getHole());
    return g;
};

module.exports = drawHoleOfPadDataTo2D;
